module.exports = __webpack_public_path__ + "img/phone.4c16fc13.png";